/**
 * Widerrufsbelehrung – Novatus Sales Academy.
 *
 * Gemäß Anlage 1 zu Art. 246a § 1 Abs. 2 Satz 1 Nr. 1 EGBGB
 * (gesetzliches Muster der Widerrufsbelehrung).
 *
 * Wichtig: Das Widerrufsrecht erlischt bei der Plattform vorzeitig, sobald der
 * Kunde im Bestellprozess beiden Zustimmungs-Checkboxen aktiv zugestimmt hat
 * (sofortige Ausführung + Verlust-Bestätigung) — § 356 Abs. 5 BGB.
 */
import LegalLayout from "../components/LegalLayout";

const WiderrufPage = () => (
  <LegalLayout
    title="Widerrufsbelehrung"
    subtitle="Für Verbraucher gemäß § 312g i. V. m. § 355 BGB"
    data-testid="widerruf-page"
  >
    <section>
      <h2>Hinweis vorab</h2>
      <p>
        Die nachfolgende Widerrufsbelehrung richtet sich ausschließlich an{" "}
        <strong>Verbraucher</strong> (§ 13 BGB). Verbraucher ist jede natürliche Person, die ein
        Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer
        selbständigen beruflichen Tätigkeit zugerechnet werden können.
      </p>
      <p>
        Schließen Sie den Vertrag als <strong>Unternehmer</strong> ab, steht Ihnen kein Widerrufsrecht zu.
      </p>
    </section>

    <section>
      <h2>Widerrufsrecht</h2>
      <p>
        Sie haben das Recht, binnen <strong>vierzehn Tagen</strong> ohne Angabe von Gründen diesen
        Vertrag zu widerrufen.
      </p>
      <p>
        Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
      </p>
      <p>
        Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
      </p>
      <p>
        <strong>NOVATUS Energie GmbH</strong>
        <br />
        Maximiliankorso 60, 13465 Berlin, Deutschland
        <br />
        Telefon: <a href="tel:+493039820570">+49 (0)30 398205700</a>
        <br />
        E-Mail: <a href="mailto:info@novatus-se.com">info@novatus-se.com</a>
      </p>
      <p>
        mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine
        E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür
        das untenstehende Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
      </p>
      <p>
        Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des
        Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
      </p>
    </section>

    <section>
      <h2>Folgen des Widerrufs</h2>
      <p>
        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen
        erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen,
        an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese
        Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion
        eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in
        keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
      </p>
    </section>

    <section>
      <h2>Besondere Hinweise – vorzeitiges Erlöschen des Widerrufsrechts</h2>
      <p>
        Gemäß § 356 Abs. 5 BGB <strong>erlischt das Widerrufsrecht bei Verträgen über die
        Bereitstellung digitaler Inhalte/Dienstleistungen vorzeitig</strong>, wenn
      </p>
      <ul>
        <li>
          Sie ausdrücklich zugestimmt haben, dass wir mit der Ausführung des Vertrages vor Ablauf
          der Widerrufsfrist beginnen,
        </li>
        <li>
          Sie bestätigt haben, dass Sie Ihr Widerrufsrecht durch diese Zustimmung mit Beginn der
          Ausführung des Vertrags verlieren, und
        </li>
        <li>
          wir Ihnen eine Bestätigung dieser Vereinbarung in Textform (z. B. per E-Mail) zur Verfügung
          gestellt haben.
        </li>
      </ul>
      <p>
        Diese Zustimmung erteilen Sie im Bestellvorgang durch ausdrückliches Anklicken zweier
        Bestätigungs-Checkboxen unmittelbar vor dem Bezahl-Vorgang.{" "}
        <strong>
          Mit Aktivierung der Checkboxen und nachfolgender Bestellung erlischt Ihr Widerrufsrecht
          mit Beginn der Bereitstellung der Trainings-Minuten (in der Regel unmittelbar nach
          erfolgreicher Zahlungsabwicklung).
        </strong>
      </p>
    </section>

    <section>
      <h2>Muster-Widerrufsformular</h2>
      <p>
        Wenn Sie den Vertrag widerrufen wollen, können Sie dieses Formular ausfüllen und an uns
        zurücksenden:
      </p>
      <div className="rounded-lg border border-novatus bg-novatus-card-2 p-5 my-4 text-sm">
        <p>An die <strong>NOVATUS Energie GmbH</strong>, Maximiliankorso 60, 13465 Berlin, info@novatus-se.com:</p>
        <p>
          Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die
          Erbringung der folgenden Dienstleistung:
        </p>
        <p>____________________________________</p>
        <p>Bestellt am (*) / erhalten am (*): _______________</p>
        <p>Name des/der Verbraucher(s): _______________</p>
        <p>Anschrift des/der Verbraucher(s): _______________</p>
        <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier): _______________</p>
        <p>Datum: _______________</p>
        <p className="text-xs text-novatus-text-3 mt-3">(*) Unzutreffendes streichen.</p>
      </div>
    </section>

    <p className="text-xs text-novatus-text-3 mt-8">
      Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
    </p>
  </LegalLayout>
);

export default WiderrufPage;
